import * as React from 'react';
import type {
  UpdateInvoiceCarrierPayload as Payload,
} from 'contracts/tracking-v2/invoice-carrier';
import { api, handleApiError } from 'services/api';

export const useUpdateInvoiceCarrier = () => {
  const updateInvoiceCarrier = React.useCallback(async (payload: Payload) => {
    const { invoiceId, ...data } = payload;
    try {
      await api.put(`/tracking-v2/invoices/${invoiceId}/carrier`, data);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    updateInvoiceCarrier,
  };
};